'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HubMap = require('self-service-api/constants/HubMap');

var _HubMap2 = _interopRequireDefault(_HubMap);

var _PurchaseTypes = require('self-service-api/constants/PurchaseTypes');

var _ContactsPicker = require('pricing-pages-unified-ui/components/common/ContactsPicker');

var _ContactsPicker2 = _interopRequireDefault(_ContactsPicker);

var _SeatsPicker = require('../common/SeatsPicker');

var _SeatsPicker2 = _interopRequireDefault(_SeatsPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdditionalUnitsPicker = function AdditionalUnitsPicker(_ref) {
  var hub = _ref.hub,
      merchandiseId = _ref.merchandiseId,
      term = _ref.term,
      additionalUnitQuantity = _ref.additionalUnitQuantity,
      setAdditionalUnitQuantity = _ref.setAdditionalUnitQuantity,
      setActiveEdition = _ref.setActiveEdition;
  var merchPurchaseType = _HubMap2.default[hub].merchPurchaseType;

  switch (merchPurchaseType) {
    case _PurchaseTypes.SEAT_BASED:
      return _react2.default.createElement(_SeatsPicker2.default, {
        merchandiseId: merchandiseId,
        additionalUnitQuantity: additionalUnitQuantity,
        onChange: setAdditionalUnitQuantity,
        term: term
      });
    case _PurchaseTypes.CONTACT_BASED:
      return _react2.default.createElement(_ContactsPicker2.default, {
        merchandiseId: merchandiseId,
        additionalUnitQuantity: additionalUnitQuantity,
        onChange: setAdditionalUnitQuantity,
        term: term,
        setActiveEdition: setActiveEdition
      });
    default:
      return null;
  }
};

exports.default = AdditionalUnitsPicker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/AdditionalUnitsPicker.js
// module id = 742
// module chunks = 3 4